/**
 * ActivateModalQr component.
 */
import QR from '@shared/assets/images/png/activateModalQr.png';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled activate modal QR code image.
 */
const ActivateModalQr = styled.img<React.CSSProperties>`
  border-radius: ${10 * Screen.widthRatio}px;
  left: 0;
  right: 0;
  top: ${492 * Screen.widthRatio}px;
  margin: auto;
  height: ${300 * Screen.widthRatio}px;
  overflow: hidden;
  position: absolute;
  width: ${300 * Screen.widthRatio}px;
`;

ActivateModalQr.defaultProps = {
  src: QR,
};

export default withImage(ActivateModalQr);
